import MobileObject from './MobileObject';

export default MobileObject;
